import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/JobModalCss.css';
import { getAllJobs, downloadDeviceDetailFile } from '../commonApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
// import { DeviceJobEmptyScreen } from '../EmptyScreens';
import moment from 'moment';
import { Loader } from '../Loader';

// Define the button component outside of JobStatusTable
const ActionButton = ({ onClick }) => (
    <button
        className="btn primary_btn text-center btn btn-primary"
        onClick={onClick}
    >
        <FontAwesomeIcon icon={faDownload} />
    </button>
);

// Move the function out of the render scope
const renderActionButton = (row, handleActionClick) => {
    return (
        <ActionButton
            onClick={() => handleActionClick(row.jobId)}
        />
    );
};

const JobStatusTable = () => {
    const [jobStatuses, setJobStatuses] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0); // Page number is 0-indexed for the API
    const [perPage, setPerPage] = useState(10);
    const [sortField, setSortField] = useState('createdDate'); // Default sort field
    const [sortOrder, setSortOrder] = useState('desc');
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(true);
    const expectedPageRef = useRef(0);

    const columns = [
        {
            name: 'Job Id',
            selector: row => row.jobId || <span style={{ position: 'absolute', left: '58px', top: '18px' }}>—</span>,
            sortable: true,
            sortField: 'jobId',
            width: "390px"
        },
        {
            name: 'Job Status',
            selector: row => row.jobStatus || <span style={{ position: 'absolute', left: '58px', top: '18px' }}>—</span>,
            sortable: true,
            sortField: 'jobStatus',
            width: "390px"
        },
        {
            name: 'Created Date',
            selector: row => moment(row.createdDate).format('YYYY-MM-DD HH:mm:ss'),
            sortable: true,
            sortField: 'createdDate',
            width: "400px"
        },
        {
            name: 'Actions',
            cell: row => renderActionButton(row, handleActionClick),
        }
    ];

    useEffect(() => {
        let isCancelled = false;

        const fetchJobs = async () => {
            setLoading(true);
            try {
                if (!isCancelled) {
                    await loadAllJobs();
                }
            } catch (error) {
                if (!isCancelled) {
                    toast.error('Failed to load Jobs');
                    console.error("Error loading jobs:", error);
                }
            } finally {
                if (!isCancelled) {
                    setLoading(false);
                }
            }
        };

        fetchJobs();
        return () => {
            isCancelled = true;
        };
    }, [page, perPage, sortField, sortOrder, searchValue]);

    const loadAllJobs = async () => {
        setLoading(true);
        try {
            const response = await getAllJobs(page, perPage, sortField, sortOrder, searchValue);
            const jobs = (response?.data?.data?.content || []).filter(
                (job) => job && typeof job === "object" && job.jobId
            );
            setJobStatuses(jobs);
            setTotalRows(response?.data?.data?.totalElements || 0);
            if (response?.data?.data?.totalElements > 0 && jobs.length === 0) {
                toast.warn(`No jobs found for page ${page + 1}`);
            }
        } catch (error) {
            toast.error('Failed to load Jobs');
        } finally {
            setLoading(false);
        }
    };

    const handleActionClick = async (id) => {
        try {
            await downloadDeviceDetailFile(id);
        } catch (error) {
            toast.error('Failed to download files');
        }
    };

    const handlePageChange = (newPage) => {
        setPage(newPage - 1);
        expectedPageRef.current = newPage - 1;
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleSort = (column, sortDirection) => {
        const sortFieldCol = column.sortField || column.selector;
        setSortField(sortFieldCol);
        setSortOrder(sortDirection);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setPage(0);
        expectedPageRef.current = 0;
    };

    return (
        <div className="custom_tab_wrapper">
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                    <ul className="nav nav-tabs" id="myTab" >
                        <li className="nav-item" >
                            <button
                                className="nav-link active"
                                id="home-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#home"
                                type="button"
                                role="tab"
                                aria-controls="home"
                                aria-selected="true"
                            >
                                Jobs: {totalRows}
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div className="tab_content_wrapper full_height_tab">

                                <div className="custom_table_action">
                                    <div>
                                        <input
                                            className="form-control custom-search-input"
                                            type="text"
                                            placeholder="Search by Name"
                                            style={{ width: '191px' }}
                                            value={searchValue}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                </div>

                                <div className="table-responsive h-100vh-150px">
                                    {loading ? (
                                        <div className="spin-loader">
                                            <Loader />
                                        </div>
                                    ) : (
                                        <div className="custom_table customs-table">
                                            {/* {jobStatuses?.length ? ( */}
                                            <DataTable
                                                columns={columns}
                                                data={jobStatuses}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                paginationPerPage={perPage}
                                                paginationDefaultPage={page + 1}
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onSort={handleSort}
                                                sortServer
                                                highlightOnHover
                                                fixedHeader
                                                fixedHeaderScrollHeight="440px"
                                            />
                                            {/* ) : (
                                            <DeviceJobEmptyScreen />
                                        )} */}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobStatusTable;